import { MutableRefObject } from 'react';
import ReactDOM from 'react-dom';
import { Editor } from '@tiptap/core';

import RichtextToolbar from 'approot/shared/richtext/richtext-toolbar';
import { ACTIVITY_BUILDER_TOOLBAR_ID } from './activity-builder.constants';
import { RichtextOptions } from 'approot/shared/richtext/richtext-toolbar';

type Props = {
  editor: Editor | null;
  showToolbar: boolean;
  toolbarRef: MutableRefObject<HTMLDivElement | null>;
} & RichtextOptions;

const ActivityBuilderRichtextToolbar = ({
  editor,
  showToolbar,
  toolbarRef,
  ...restRichtextProps
}: Props) => {
  const domNode = document.getElementById(ACTIVITY_BUILDER_TOOLBAR_ID);

  if (!domNode || !editor || !showToolbar) return null;

  return ReactDOM.createPortal(
    <RichtextToolbar editor={editor} ref={toolbarRef} {...restRichtextProps} />,
    domNode
  );
};

export default ActivityBuilderRichtextToolbar;
